import { Shimmer } from '../../commenda-ai/ai-elements/shimmer';

import CommendaAvatar from './ChatAvatar/CommendaAvatar';

const AgentThinkingRow = () => (
  <div
    className="flex gap-md items-center w-full pb-xl"
    role="status"
    aria-label="Commenda Agent is thinking"
  >
    <CommendaAvatar />
    <Shimmer as="span" className="txt-small-regular">
      Thinking…
    </Shimmer>
  </div>
);

export default AgentThinkingRow;
